import { BaseClient } from '../client';
import { LojistasQueNaoCompram } from './report.mocks';
import { TReportShopkeeperWithoutPurchase } from './report.types';

interface setFilter {
	dataInicial?: string;
	dataFinal?: string;
}

export const postLojistaNaoCompra = async (filters: setFilter) => {
	 if (process.env.NODE_ENV === 'development') {
	 	return [LojistasQueNaoCompram];
	 }

	try {
		const response = await BaseClient.post<TReportShopkeeperWithoutPurchase[]>(`/Relatorio/PostRelatorioLojistaQueNaoCompra`, filters).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
